import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TransportOrderCatalogInitialState, TransportOrderCatalogLoad } from './transport-order-catalog.actions';
import { NotificationService } from '../../../../../../common/services';
import { TransportOrderCatalogService } from './transport-order-catalog.service';
import { TransportOrderPrimary } from '../../models';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../../common/models';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type TransportOrderCatalogStateModel = ListServerPaginationStateModel<TransportOrderPrimary>;

const initialState: TransportOrderCatalogStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<TransportOrderCatalogStateModel>({
  name: 'transportOrderCatalog',
  defaults: initialState,
})
@Injectable()
export class TransportOrderCatalogState {
  constructor(
    private transportOrderCatalogService: TransportOrderCatalogService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: TransportOrderCatalogStateModel): TransportOrderCatalogStateModel {
    return state;
  }

  @Selector()
  static getItems(state: TransportOrderCatalogStateModel): TransportOrderPrimary[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: TransportOrderCatalogStateModel): boolean {
    return state.loaded;
  }

  @Action(TransportOrderCatalogLoad)
  getTransportOrderCatalog(
    ctx: StateContext<TransportOrderCatalogStateModel>,
    { payload }: TransportOrderCatalogLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportOrderCatalogService.getTransportOrderCatalog(payload).pipe(
      map((transportOrderCatalog: TransportOrderCatalogStateModel) => {
        ctx.patchState({
          ...transportOrderCatalog,
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportOrderCatalogInitialState)
  setInitialState(ctx: StateContext<TransportOrderCatalogStateModel>): void {
    ctx.setState(initialState);
  }
}
